
import { mapGetters,mapActions } from 'vuex'
export default {
 name: "Module",
 props: {
    id: {
      default: '',
      type: String,
    },
    active: {
      default: '',
      type: String,
    },
 },
 data() {
    return {
      startActive: this.active !== '',
    }
  },
  computed: {
    ...mapGetters({
      activeModule : 'pages/getActiveModule' || this.id,
    }),
  },
  methods: {
    ...mapActions({
      updateActiveModule: 'pages/updateActiveModule', // map `this.add()` to `this.$store.commit('increment')`
    }),
    updateModule(){
      this.startActive = false
      this.updateActiveModule(this.id)
      console.log('Active Module: ',this.activeModule)
      this.$nextTick(() => {
        const element = document.getElementById('infobox_' + this.id)
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        })
      })
    }
  },

}
